try {
  require("@rails/ujs").start()
}catch(e){
}

require("../detect-ie")
require("../utilities.js")
require("../presentable.js")
require("../present-tooltip.js")
require("../topshops/open-position-modal")
